<template>
  <FKBreadCrumb :page="$t('page.policies')" />
  <PoliciesList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import PoliciesList from "@/components/FK/Profile/Policies/PoliciesList.vue";

export default defineComponent({
  name: "PoliciesPage",
  components: {
    FKBreadCrumb,
    PoliciesList
  },

});
</script>